import { render } from "./GameLeaderboard.vue?vue&type=template&id=0a8ec810&scoped=true"
import script from "./GameLeaderboard.vue?vue&type=script&lang=js"
export * from "./GameLeaderboard.vue?vue&type=script&lang=js"

import "./GameLeaderboard.vue?vue&type=style&index=0&id=0a8ec810&scoped=true&lang=css"

import exportComponent from "/builds/unifybusiness/pics/games/arcade-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8ec810"]])

export default __exports__